<template>
  <div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Disable by role setting?
        <input type="checkbox" v-model="control.disableByRoleSetting">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        External Data
        <icon-tooltip icon="informationOutline"
                      text="Your API-Endpoint URL - GET Method. It must return an Array. Read more on Documentation"/>
      </label>

      <v-autocomplete
          v-model="selectedItem"
          :items="external_data_items"
          item-text="name"
          item-value="id"
          label="Define External Data"
          single-line
          return-object
          :class="styles.FORM.FORM_CONTROL"
          @change="loadDataItems()"
          dense
      />
    </div>
    <div v-if="external_data_headers.length > 0">
      <div :class="styles.FORM.FORM_GROUP">
        <label>
          Value Key of your Object
          <icon-tooltip icon="informationOutline"
                        text="[{'value': '',...}] => value"/>
        </label>

        <v-autocomplete
            :class="styles.FORM.FORM_CONTROL"
            v-model="control.field_text"
            :items="external_data_headers"
            label="Define the Key of the object"
            single-line
            dense
        />
      </div>

      <div :class="styles.FORM.FORM_GROUP">
        <label>
          Text Value of your Object
          <icon-tooltip icon="informationOutline"
                        text="[{'text': '',...}] => text"/>
        </label>

        <v-autocomplete
            :class="styles.FORM.FORM_CONTROL"
            :items="external_data_headers"
            v-model="control.field_value"
            label="Define the value of the object"
            single-line
            dense
        />
      </div>



      <div :class="styles.FORM.FORM_GROUP">
        <label>
          Hint value of the object
          <icon-tooltip icon="informationOutline"
                        text="[{'text': '',...}] => text"/>
        </label>

        <v-select
            :class="styles.FORM.FORM_CONTROL"
            :items="external_data_headers"
            v-model="control.field_hint"
            label="Define the value of the hint object"
            single-line
        />
      </div>
    </div>
  </div>
</template>

<script>
import {BaseControlConfigSkeleton} from 'v-form-builder';
import {readAdminExternalDataList} from '@/store/admin/getters';
import {dispatchGetExternalDataListAdmin} from '@/store/admin/actions';


export default {
  name: 'DropdownConfigView',
  extends: BaseControlConfigSkeleton,
  data: () => ({
    selectedItem: null,
    external_data_items: [],
    external_data_headers: [],
  }),

  methods: {

    loadDataItems() {
      if (this.selectedItem) {
        this.control.external_data_id = this.selectedItem.id;
        this.external_data_headers = this.selectedItem.headers;
      }
    },

  },

  async mounted() {
    await dispatchGetExternalDataListAdmin(this.$store);
    this.external_data_items = await readAdminExternalDataList(this.$store);
    if (this.control.external_data_id > 0) {
      this.selectedItem = this.external_data_items.filter((e) => e.id === this.control.external_data_id);
    }
  },
};
</script>

<style scoped>

</style>
